import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { mcPost } from "./api";

export const SettingsDialog = ({ open, onClose, token, settings, onSaved }) => {
  const [f, setF] = useState(settings);
  useEffect(() => setF(settings), [settings, open]);
  const save = async () => {
    try {
      await mcPost("settings/save", { token, target_food_cost_pct: parseFloat(f.target_food_cost_pct), amber_band_pct: parseFloat(f.amber_band_pct),
        low_margin_pct: parseFloat(f.low_margin_pct), avg_days: parseInt(f.avg_days, 10) });
      toast.success("Settings saved"); onSaved(); onClose();
    } catch (e) { toast.error(e.message); }
  };
  const fld = (k, l, testid) => (
    <label className="text-xs space-y-1 block">{l}
      <Input type="number" value={f?.[k] ?? ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={testid} />
    </label>
  );
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="costing-settings-dialog">
        <DialogHeader><DialogTitle>Costing settings (planning only)</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {fld("target_food_cost_pct", "Target food cost %", "settings-target")}
          {fld("amber_band_pct", "Amber band above target (pts)", "settings-amber")}
          {fld("low_margin_pct", "Low-margin threshold GM %", "settings-low-margin")}
          <label className="text-xs space-y-1 block">Averaging period
            <select className="h-9 w-full rounded border border-stone-300 px-2 text-sm" value={f?.avg_days || 30}
              onChange={(e) => setF({ ...f, avg_days: e.target.value })} data-testid="settings-days">
              {[7, 30, 60, 90].map((d) => <option key={d} value={d}>{d} days</option>)}
            </select>
          </label>
        </div>
        <p className="text-[11px] text-stone-500">Green ≤ target · Amber ≤ target + band · Red above. Grey = data missing.</p>
        <DialogFooter><Button onClick={save} data-testid="settings-save-btn">Save</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const RequestsDialog = ({ open, onClose, token, center, canApprove, onDecided }) => {
  const [rows, setRows] = useState([]);
  const load = async () => { try { setRows((await mcPost("price/requests", { token, center, status: "PENDING" })).requests); } catch (e) { toast.error(e.message); } };
  useEffect(() => { if (open) load(); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const decide = async (id, approve) => {
    try { await mcPost("price/decide", { token, request_id: id, approve }); toast.success(approve ? "Approved & applied" : "Rejected"); load(); onDecided(); }
    catch (e) { toast.error(e.message); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="price-requests-dialog">
        <DialogHeader><DialogTitle>Pending price-change requests · {center}</DialogTitle></DialogHeader>
        {rows.length === 0 ? <p className="text-sm text-stone-500" data-testid="requests-empty">No pending requests.</p> : (
          <ul className="space-y-2 text-sm">
            {rows.map((r) => (
              <li key={r.id} className="flex items-center justify-between gap-2 border-b pb-2" data-testid={`request-${r.id}`}>
                <span><b>{r.menu_item_name}</b> → {r.price} (eff. {r.effective_date || "today"}) · {r.requested_by} · {r.reason}</span>
                {canApprove && <span className="flex gap-1">
                  <Button size="sm" onClick={() => decide(r.id, true)} data-testid={`approve-${r.id}`}>Approve</Button>
                  <Button size="sm" variant="outline" onClick={() => decide(r.id, false)} data-testid={`reject-${r.id}`}>Reject</Button>
                </span>}
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
};
